import { useState, useEffect } from "react";
import { callBackend } from "../components/callBackend";
import { Container, Form } from "react-bootstrap";
import DataTable from "../components/DataTable";
import Loader from "../components/Loader";
import OrderDetailsModal from "../components/OrderDetailsModal";
import { NSSC_YEAR } from "../data/config";

const STATUS_OPTIONS = [
	{ value: "PAID", label: "Paid" },
	{ value: "PENDING", label: "Pending" },
	{ value: "FAILED", label: "Failed" },
	{ value: "USER_DROPPED", label: "User Dropped" },
	{ value: "CANCELLED", label: "Cancelled" },
	{ value: "all", label: "All Statuses" },
];

function formatDate(value) {
	if (!value) return "";
	const d = new Date(value);
	if (Number.isNaN(d.getTime())) return "";
	return d.toLocaleString();
}

export default function AllOrders() {
	const [count, setCount] = useState(0);
	const [orderData, setOrderData] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [statusFilter, setStatusFilter] = useState("PAID");
	const [selectedOrder, setSelectedOrder] = useState(null);

	let pref = JSON.parse(localStorage.getItem("nssc-admin-pref"));
	const [tableControls, setTableControls] = useState(
		pref && pref.pageID == 6 && pref.v === 1
			? pref
			: {
					page: 1,
					length: 100,
					sortField: "_id",
					sortDir: -1,
					search: "",
			  }
	);

	const columns = {
		_id: "Serial Number",
		orderId: "Order ID",
		pid: "PID",
		fName: "First Name",
		lName: "Last Name",
		itemsSummary: "Items",
		amount: "Amount",
		status: "Status",
		paidAt: "Paid At",
		createdAt: "Created At",
	};

	useEffect(() => {
		if (!localStorage.getItem("nssc-admin-token")) {
			window.location.href = "/login";
			return;
		}
		setIsLoading(true);
		callBackend({
			method: "GET",
			endpoint: "/admin/merchandise/orders/",
			data:
				"sortField=" +
				tableControls.sortField +
				"&sortDir=" +
				tableControls.sortDir +
				"&first=" +
				(0 + tableControls.length * (tableControls.page - 1)) +
				"&limit=" +
				tableControls.length +
				"&search=" +
				encodeURIComponent(tableControls.search || "") +
				"&status=" +
				encodeURIComponent(statusFilter),
			onSuccess: (res) => {
				const rows = (res.data || []).map((order) => ({
					...order,
					_raw: order,
					amount:
						typeof order.amount === "number"
							? "₹" + order.amount.toFixed(2)
							: order.amount,
					paidAt: formatDate(order.paidAt),
					createdAt: formatDate(order.createdAt),
				}));
				setOrderData(rows);
				setCount(res.count || res.total || 0);
				setIsLoading(false);
			},
			onError: (error) => {
				console.error("Failed to fetch orders:", error);
				setIsLoading(false);
			},
		});
		localStorage.setItem(
			"nssc-admin-pref",
			JSON.stringify({ ...tableControls, pageID: 6, v: 1 })
		);
	}, [tableControls, statusFilter]);

	return (
		<Container
			fluid
			style={{
				marginTop: "20px",
				marginBottom: "20px",
			}}
		>
			<h1>NSSC {NSSC_YEAR} Store Orders</h1>

			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: "10px",
					marginBlock: "12px",
					flexWrap: "wrap",
				}}
			>
				<label htmlFor="orders-status-filter" style={{ fontWeight: "bold" }}>
					Status:
				</label>
				<Form.Select
					id="orders-status-filter"
					value={statusFilter}
					onChange={(e) => {
						setStatusFilter(e.target.value);
						setTableControls({ ...tableControls, page: 1 });
					}}
					style={{ maxWidth: "220px" }}
				>
					{STATUS_OPTIONS.map((opt) => (
						<option key={opt.value} value={opt.value}>
							{opt.label}
						</option>
					))}
				</Form.Select>
			</div>

			{isLoading ? (
				<Loader />
			) : (
				<DataTable
					columns={columns}
					data={orderData}
					count={count}
					tableControls={tableControls}
					setTableControls={setTableControls}
					searchPlaceholder="Search order id, pid, cf payment id..."
					onRowClick={(row) => setSelectedOrder(row._raw)}
				/>
			)}

			<OrderDetailsModal order={selectedOrder} onHide={() => setSelectedOrder(null)} />
		</Container>
	);
}
